import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

const getAllBannerImages = async (ctx: QueryFunctionContext) => {
  // Extract all dynamic params from the query key

  const {data}: {data: IBanner[]} = await request.get(
    `api/v2/store/banner-list-redesign${
      !ctx.queryKey[1] ? '?type=' + ctx.queryKey[1] : ''
    }`,
  );

  return data;
};

export default getAllBannerImages;
